import { CSSProperties, VFC } from "react";
import { css, theme } from "src/styles/theme";
import { editorGrid } from "../editor.constants";

export interface InfiniteCanvasBackgroundProps {
  x: number;
  y: number;
}

export const InfiniteCanvasBackground: VFC<InfiniteCanvasBackgroundProps> = ({
  x,
  y,
}) => {
  const customProps = {
    "--pos-x": `${-x}px`,
    "--pos-y": `${-y}px`,
    "--offset-x": `0px`,
    "--offset-y": -((editorGrid.y - editorGrid.nodeHeight) / 2) + "px",
  } as CSSProperties;

  return <div className={$canvasBackground()} style={customProps}></div>;
};

const svg = `
  <svg 
    width="${editorGrid.x}"
    height="${editorGrid.y}"
    viewBox="0 0 ${editorGrid.x} ${editorGrid.y}"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle r="1" fill="${theme.colors.slate8.value}"/>
    <circle cx="${editorGrid.x}" r="1" fill="${theme.colors.slate8.value}" />
    <circle cx="${editorGrid.x}" cy="${editorGrid.y}" r="1" fill="${theme.colors.slate8.value}"/>
    <circle cy="${editorGrid.y}" r="1" fill="${theme.colors.slate8.value}"/>
  </svg>
`;

const canvasBg = `data:image/svg+xml;base64,${window.btoa(svg)}`;

const $canvasBackground = css({
  height: "100%",
  backgroundImage: `url('${canvasBg}')`,
  backgroundPositionX: "calc(var(--pos-x) + var(--offset-x))",
  backgroundPositionY: "calc(var(--pos-y) + var(--offset-y))",
  pointerEvents: "none",
});
